import billableEventsComponent from "./billable_events.component";

import billableEventsAll from './all';
import billableEventsCreate from './create';
import billableEventsEdit from './edit';

let billableEventsModule = angular.module('billableEvents', [
    billableEventsAll,
    billableEventsCreate,
    billableEventsEdit
])

    .component('billableEvents', billableEventsComponent)

    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';
        $stateProvider
            .state('billable_events.all', {
                url: '/all/:page',
                component: 'billableEventsAll',
                data: {
                    requireLogin: true,
                    requireACL: 'tnt_billing_billable_events.view'
                },
            })

            .state('billable_events.create', {
                url: '/create',
                component: 'billableEventsCreate',
                // parent: 'tntBilling',
            })

            .state('billable_events.edit', {
                url: '/edit/:id',
                component: 'billableEventsEdit'
            })
    })
    .name;

export default billableEventsModule;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/index.js